import { registerAdditionalMessages } from "@hoppscotch/common/modules/i18n"

/**
 * Org wording for common's self-host chat copy ("this server").
 *
 * Call after `createHoppApp`: `en` is merged at once, and every other locale
 * falls back to it since none translates these keys.
 */
export const registerAIChatCopy = () =>
  registerAdditionalMessages("en", {
    ai_experiments: {
      chat: {
        no_models_subtitle:
          "An org admin needs to add a provider in the admin dashboard before the assistant can answer.",
        errors: {
          chat_disabled:
            "The assistant is off for your organization. Ask an org admin.",
          provider_misconfigured:
            "The AI provider rejected your organization's setup. Ask an org admin.",
        },
      },
    },
  })
